import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Coerce an axios error (incl. FastAPI 422 validation arrays) into a readable string.
// Never surfaces a raw HTML gateway/Cloudflare error page to the user.
export function apiErr(e, fallback = "Something went wrong") {
  const data = e?.response?.data;
  const d = data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const msg = d.map((x) => (typeof x === "string" ? x : x?.msg)).filter(Boolean).join(", ");
    return msg || fallback;
  }
  if (d && typeof d === "object") return d.msg || fallback;
  // Gateway/5xx or an HTML error page → show the friendly fallback, never raw HTML.
  if (e?.response?.status >= 500) return fallback;
  if (typeof data === "string" && data.trim().startsWith("<")) return fallback;
  return e?.message || fallback;
}

export function formatNum(n, opts = {}) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-SG", {
    maximumFractionDigits: opts.decimals ?? 2,
    minimumFractionDigits: opts.decimals ?? 0,
  }).format(n);
}

export function formatSgd(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-SG", {
    style: "currency",
    currency: "SGD",
    maximumFractionDigits: 0,
  }).format(n);
}

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  tenant_admin: "Tenant Admin",
  esg_manager: "ESG Manager",
  data_officer: "Data Officer",
  approver: "Report Approver",
  auditor: "Auditor",
  board: "Board Member",
};
